import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchImage = (image: any) => ({
    type: 'FETCH_IMG_SUCCESS',
    payload: image,
});
export const fetchDatas = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});



export const fetchImageData = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:9,doctorid:id};
            const apiname = SUPRIVISOR_API.sviewassistantsreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchImage(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchViewAssReortsData = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:7,doctorid:id};
            const apiname = SUPRIVISOR_API.sviewassistantsreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDatas(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

